import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useAuth, type AuthOrganisation } from "./AuthContext";

interface OrganisationContextValue {
  organisation: AuthOrganisation | null;
  isModuleActive: (moduleCode: string) => boolean;
}

const OrganisationContext = createContext<OrganisationContextValue | null>(null);

export function OrganisationProvider({ children }: { children: ReactNode }) {
  const { activeOrganisation } = useAuth();

  const value = useMemo<OrganisationContextValue>(() => {
    const modules = new Set(activeOrganisation?.activeModules ?? []);
    return {
      organisation: activeOrganisation,
      isModuleActive: (code: string) => modules.has(code),
    };
  }, [activeOrganisation]);

  return <OrganisationContext.Provider value={value}>{children}</OrganisationContext.Provider>;
}

export function useOrganisation(): OrganisationContextValue {
  const ctx = useContext(OrganisationContext);
  if (!ctx) throw new Error("useOrganisation must be used within an OrganisationProvider");
  return ctx;
}
